import Vue from 'vue';

export async function apartmentsOverviewSearchData(context: Vue) {
	const locationStats = await context.$locationService.fetchLocationStatsByCatalogNumber(context.$route.params.locationCatalogNumber, {
		includeOverviewStats: true
	});

	return {
		locationStats
	};
}
